import BENEFICIARY_SUBJECT_TYPE_KEY from '@Domain/Subjects/BeneficiarySubjectTypeKey';
import buildSubjectListPath from '@UI/Pages/Beneficiaries/Shared/Helpers/buildSubjectListPath';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import BeneficiaryStaffAssignment from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/BeneficiaryMembers/BeneficiaryStaffAssignment';
import useSubjectAddressParams from '@UI/Pages/Beneficiaries/Hooks/Params/useSubjectAddressParams';
import BeneficiariesNotifications from '@UI/Pages/Beneficiaries/Shared/BeneficiariesNotifications';
import SubjectBreadcrumb from '@UI/Pages/Beneficiaries/Shared/SubjectBreadcrumb';
import SubjectReadingColumn from '@UI/Pages/Beneficiaries/Shared/SubjectScreen/SubjectReadingColumn';
import SubjectScreenContainer from '@UI/Pages/Beneficiaries/Shared/SubjectScreen/SubjectScreenContainer';
import MembersContent from '@UI/Pages/Subjects/SubjectDetails/Pages/Members/MembersContent';
import SubjectsNotifications from '@UI/Pages/Subjects/SubjectsNotifications';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfirmDialog } from '@verclam/ui-kit';

const membersItems = [{ label: 'Membres' }] as const;

/**
 * Members screen of a beneficiary: the generic `MembersContent` addressed to the beneficiary, then the
 * staff panel of the structure. The bare `<ConfirmDialog />` receives the imperative `confirmDialog()`
 * calls of the member rows. Redirects to the beneficiary list when the route's `beneficiary` segment is not
 * a valid id.
 */
const BeneficiaryMembers: React.FC = () => {
	const navigate = useNavigate();
	const { subject } = useSubjectAddressParams();

	React.useEffect(() => {
		if (subject === null) {
			navigate(buildSubjectListPath(BENEFICIARY_SUBJECT_TYPE_KEY));
		}
	}, [subject, navigate]);

	return (
		<SubjectScreenContainer>
			<ConditionalLoader data={subject}>
				{(presentSubject) => (
					<React.Fragment>
						<SubjectBreadcrumb subject={presentSubject} items={membersItems} />
						<SubjectReadingColumn>
							<MembersContent subject={presentSubject} />
							<BeneficiaryStaffAssignment beneficiaryId={presentSubject.subjectId} />
						</SubjectReadingColumn>
					</React.Fragment>
				)}
			</ConditionalLoader>
			<ConfirmDialog />
			<SubjectsNotifications />
			<BeneficiariesNotifications />
		</SubjectScreenContainer>
	);
};

export default BeneficiaryMembers;
